import { ReferralMedical } from "src/app/shared/models/systems/referral-medical.model";
import { AppStorageService, STORAGE } from "./app-storage.service";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root',
})
export class ReferralMedicalService {

    constructor(private appStorageService: AppStorageService){
    }

    setReferralMedical(referralMedical: ReferralMedical){
        this.appStorageService.setItemSession(STORAGE.REFERRAL_MEDICAL, referralMedical);
    }

    isReferralMedical(): boolean{
        return this.appStorageService.getItemSession(STORAGE.REFERRAL_MEDICAL) != null;
    }

    getReferralMedical(): ReferralMedical{
        return this.appStorageService.getItemSession(STORAGE.REFERRAL_MEDICAL) as ReferralMedical;
    }
}